import { React, useEffect, useState } from "react";
import secureLocalStorage from "react-secure-storage";
import HeaderLower from "./HeaderLower";
import ContentPopup from "./ContentPopup";
import { Icon } from "@iconify/react";
import { FaCheckCircle } from "react-icons/fa";
// import {assignmentCheck} from "@iconify-icons/zmdi/assignment-check";
import { Navigate, useNavigate } from "react-router-dom";
import Footer from "./Footer";
import LogService from "../services/log.service";
import StorageService from "../services/storage.service";
import { Helmet } from "react-helmet";

function Thankyou(props) {
  const TITLE = process.env.REACT_APP_API_SITE_TITLE + " | Thank You";
  const navigate = useNavigate();

  var redemptionForm = secureLocalStorage.getItem("UserForm");

  var redemptionObject = redemptionForm ? JSON.parse(redemptionForm) : false;

  const [showPopup, setShowPopup] = useState(redemptionObject.popup);

  // FIXME
  localStorage.removeItem("returnthankyou", true);
  localStorage.removeItem("voucher", "");
  localStorage.removeItem("returnpage", false);
  localStorage.removeItem("userformopen");
  localStorage.removeItem("userform");

  const isVoucher = localStorage.getItem("Thankyou");
  const Voucher = localStorage.getItem("voucher");

  useEffect(() => {
    if (redemptionObject === false) {
      navigate("/");
    }
    if (isVoucher !== "true" && !Voucher) {
      localStorage.setItem("isVoucher", false);

      navigate("/");
    } else {
      localStorage.setItem("Thankyou", false);
    }
  }, []);

  // StorageService.destroyRedThankStorage();

  // const isVoucher = StorageService.getThankStatus();
  // const Voucher = StorageService.getVoucher();
  // if (
  //   isVoucher !== "true" ||
  //   Voucher === undefined ||
  //   props.history.location.zipcode === "undefined"
  // ) {
  //   StorageService.setVoucherStatus(false);
  //   return <Redirect to="/" />;
  // } else {
  //   StorageService.setThankStatus(false);
  // }
  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>

      <div className="container-fluid">
        {/* <HeaderLower /> */}
        <div className="white-box thank">
          <h1 className="text-center">{process.env.REACT_APP_THANKYOUTITLE}</h1>
          {/* <BsFillCheckCircleFill/> */}
          {/* <Icon icon={BsFillBagCheckFill}/> */}
          {/* <Icon icon={assignmentCheck} /> */}
          <FaCheckCircle />
          <p>Thank You! {redemptionObject.name}</p>
          <ul className="info-data">
            <li key="uniqueId56">
              {redemptionObject.name} {redemptionObject.lname}
            </li>
            <li key="23ff">{redemptionObject.city}</li>
            <li key="uniqueId1">
              {redemptionObject.state} {redemptionObject.address}{" "}
              {redemptionObject.zipcode}
            </li>
          </ul>
          {/* <p>
            Once your order has processed, the link to your rewards card will be
            EMAILED to you by the Virtual Rewards Center.
          </p> */}
          {/* <p>
          Expect an email within 5 business days from{" "}
          <a href="mailto:notification@prepaiddigitalsolutions.com">
          <strong>{process.env.REACT_APP_PREP}</strong>
          </a>{" "}
          or{" "}<br/>
          <a href="mailto:no-reply@hawkmarketplace.com">
            <strong>{process.env.REACT_APP_MARKET_PLACE}</strong>
          </a>{" "} we suggest adding these email addresses to your SAFE SENDER list in
          your email settings.
          </p> */}
          <p>
          Expect an email(s) within 5 business days from{" "}
          <a href={"mailto:" + process.env.REACT_APP_DESC_REWARD}>
            {process.env.REACT_APP_DESC_REWARD}
          </a>
          , <br />
          <a href={"mailto:" + process.env.REACT_APP_PREP}>
            {process.env.REACT_APP_PREP}
          </a>{" "}
          or{" "}
          <a href={"mailto:" + process.env.REACT_APP_MARKET_PLACE}>
            {process.env.REACT_APP_MARKET_PLACE}
          </a>{" "}
          <br />
          Please add these email addresses to your safe senders list in your
          email setting.
          <br />
          Once you receive your email(s) you may use the reward virtually or
          request plastic cards to be mailed.
          </p>
          <p>
            You will need to click that link to finalize your order and select
            your preferred delivery method.
          </p>
          <p>
            Please do not discard your certificate until you receive your reward
            card.
          </p>
          <p>
            If you have any questions, please call{" "}
            <a href={"tel:" + process.env.REACT_APP_DESC_CONTACTUS + '"'}>
              <strong>{process.env.REACT_APP_DESC_CONTACTUS}</strong>
            </a>
          </p>
          <p>
            or email us at{" "}
            <span className="blue">
              <a
                href={"mailto:" + process.env.REACT_APP_DESC_CUSTOMERCARE + '"'}
              >
                <strong>{process.env.REACT_APP_DESC_CUSTOMERCARE}</strong>
              </a>
            </span>
          </p>
          <p> and one of our reward card specialists will get back to you.</p>
          <p>Enjoy your card!</p>
          <p className="note">
            PLEASE NOTE: If the card you have selected is out of stock, we will
            send you a Mastercard Reward Card instead, which can be used at
            thousands of retailers instead of just one place!
          </p>
        </div>
      </div>
      {showPopup === "true" && <ContentPopup />}
      <Footer />
    </>
  );
}
export default Thankyou;
